function handleVolumePricing() {
  document.querySelectorAll("volume-pricing .quantity-discount-list li").forEach((card) => {
    card.addEventListener("click", function () {
      const span = card.querySelector("span[data-minimum-qty]");
      if (span) {
        const minQty = span.getAttribute("data-minimum-qty");
        const input = document.querySelector(".product-info__block .qty-input__input.input");
        if (input) {
          input.value = minQty;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  });
}

// Call the function after DOM is loaded
document.addEventListener("DOMContentLoaded", handleVolumePricing);
